import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';

export const UserRoute = ({ children }) => {
  const { role, isLoading } = useAuth();

  if (isLoading) {
    return null;
  }

  if (role !== 'USER') {
    // If authenticated as ADMIN trying to access user portal, redirect to admin dashboard
    return <Navigate to="/admin" replace />;
  }

  return children;
};

export default UserRoute;
